/* eslint-disable comma-dangle */
/* eslint-disable quotes */
import * as firebase from "firebase/app";
import "firebase/firestore";
import Model from "./model";
import AuthService from "../services/auth.service";

export default class Reservation extends Model {
  uid;
  type; // reservation | invitation
  reservedBy; // User
  user; // User
  parking; // Parking
  createdAt; // Timestamp
  date; // Date
  estimatedExit; // Timestamp
  vehicle; // { brand, model, color, plate }
  status; // open | checked-in | checked-out | closed
  logs; // [Log]

  _reservedByRef;
  _userRef;
  _parkingRef;
  _hydration;

  /**
   *
   * @param {{
   *  type: string,
   *  user: User,
   *  parking: Parking,
   *  date: Date,
   *  estimatedExit: Date
   * }} hydration
   */
  static async buildHydrationForCreation({
    type,
    user,
    parking,
    date,
    estimatedExit
  }) {
    return {
      type,
      reservedBy: await AuthService.getCurrentUser(),
      user,
      parking,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      date: firebase.firestore.Timestamp.fromDate(date),
      estimatedExit: firebase.firestore.Timestamp.fromDate(estimatedExit),
      vehicle: user.getVehicle ? user.getVehicle() : "unregistered",
      status: "open",
      logs: []
    };
  }

  /**
   *
   * @param {{
   *  type: string,
   *  reservedBy: User,
   *  user: User,
   *  parking: Parking,
   *  createdAt: firebase.firestore.FieldValue,
   *  date: Date,
   *  estimatedExit: Date,
   *  vehicle: { car: string, color: string, plates: string },
   *  status: string,
   *  logs: Array
   * }} hydration
   */
  hydrate(hydration) {
    const {
      uid,
      type,
      reservedBy,
      user,
      parking,
      createdAt,
      date,
      estimatedExit,
      vehicle,
      status,
      logs
    } = hydration;
    this.uid = uid;
    this.type = type;
    this.reservedBy = reservedBy;
    this.user = user;
    this.parking = parking;
    this.createdAt = createdAt;
    this.date = date;
    this.estimatedExit = estimatedExit;
    this.vehicle = vehicle;
    this.status = status;
    this.logs = logs;
    this._reservedByRef = this.reservedBy.selfRef;
    this._userRef = this.user.selfRef;
    this._parkingRef = this.parking.selfRef;
    this._hydration = hydration;
  }
}
